import { number } from 'echarts';
import { LookupDTO } from './lookup.model';

/**
 * Modello per memorizzare i dati delle scadenze della fattura
 */
export class DueInvoiceDTO {
  public ID: number = 0;
  public ExpireDate: Date;
  public Total: number;
  public PaymentType: LookupDTO;    
  public NamirialPayLink: NamirialPayLinkDTO;
  public flagNamirialPayLink: boolean;
  public ScheduleData: DueInvoiceScheduleDTO;
}

export class DueInvoiceScheduleDTO {
  public ID: number;
  public FK_Document: number;
  public FK_PassiveDocument: number;
  public ExpireDate: Date;
  public Total: number;
  public FK_PaymentType: number;
  public PaymentType: LookupDTO;
  public ResidualAmount: number;
  public ReceiptAmount: number;
  public ReceiptDate: Date;
  public CostRevenue: string;
  public Code: string;
  public DocumentTypeXML: string;
  public Denomination: string;
  public RifAmmFE: string;
  public Number: string;
  public ReminderLevel: number;
  public FK_NamirialPayLink: number;
  public NamirialPayLink: NamirialPayLinkDTO;
  public hasNamirialPayLogs: boolean;
}
//SOLO CLIENT
export class DueInvoiceScheduleTotals {
  public TotalScheduler: number;
  public TotalResidualAmount: number;
  public TotalReceiptAmount: number;
}
export class DueInvoiceCalculateDTO {
  public FK_Document: number;
  public DocumentDate: Date;
  public DocumentAmount: number;
  public FK_PaymentCondition: number;

}


export class NamirialPayLinkDTO {  
  public ServicePay: number;
  public idOperazioneFP: string;
  public idOperazione: string;
  public dataOraSottomissione: Date;
  public dataOraValiditaLink: Date;
  public RequestReponse: string;
  public RequestStatus: number;
  public PayStatoOperazione: string;
  public PayDateNotify: Date;
  public PayResponse: string;
  public PayStatoOperazioneEnum: NamirialPayStatusEnum ;
}

export enum NamirialPayStatusEnum {
  NOTHING = -1,
  CARICATA = 0,
  INSOLUTA = 1,
  IN_CORSO = 2,
  ANNULLATA=3,
  SCADUTA=4,
  BAD_INFO=5,
  INCASSATA=6,
  DA_INVIARE=7
}